namespace Serenity.EmailClient {

    export interface MailViewerProps {
        folder: string;
        flatFolderList: EmailFolder[];
        uid: number;
        onClose: () => void;
    }

    export interface MailViewerState {
        message: EmailItem;
    }

    export class MailViewer extends React.Component<MailViewerProps, MailViewerState> {
        private loadTimeout: number;

        constructor(props: MailViewerProps) {
            super(props);

            this.state = {
                message: {}
            }
        }

        componentDidMount() {
            this.load();
        }

        componentWillReceiveProps(newProps: MailViewerProps) {
            if (newProps.folder !== this.props.folder ||
                newProps.uid !== this.props.uid)
                this.load();
        }

        back() {
            Q.Router.navigate("folder/" + encodeURIComponent(this.props.folder), true);
        }

        loadMessage(folder: string, uid: number): PromiseLike<any> {

            return EmailService.RetrieveMessage({
                Folder: folder,
                UniqueId: uid
            }, response => {
                this.setState({
                    message: response.Entity
                });
            });
        }

        load() {
            clearTimeout(this.loadTimeout);
            this.loadTimeout = setTimeout(() => {
                if (this.props.folder && this.props.uid != null)
                    this.loadMessage(this.props.folder, this.props.uid);
                else {
                    this.setState({
                        message: {}
                    });
                }
            }, 500);
        }

        deleteMessage() {
            Q.confirm(Q.text("Site.EmailClient.DeleteMessageConfirmation"), () => {
                EmailService.DeleteMessages({
                    Folder: this.props.folder,
                    UniqueIds: [this.props.uid]
                }, response => {
                    Q.notifyInfo("Site.EmailClient.DeleteMessageSuccess");
                    this.props.onClose();
                    this.back();
                });
            });
        }

        moveToFolder(target: string) {
            if (!target)
                return;

            EmailService.Move({
                SourceFolder: this.props.folder,
                UniqueIds: [this.props.uid],
                TargetFolder: target
            }, response => {
                Q.notifySuccess("Site.EmailClient.MoveMessageSuccess");
                this.props.onClose();
                this.back();
            });
        }

        getDateText() {
            return Q.formatDate(this.state.message.Date, "dd.MM.yyyy HH:mm");
        }

        reply(all?: boolean, forward?: boolean) {
            EmailService.Reply({
                Folder: this.props.folder,
                UniqueId: this.props.uid,
                ReplyToAll: all,
                Forward: forward
            }, response => {
                var dlg = new EmailComposeDialog();
                dlg.reply = response;
                dlg.dialogOpen();
            })
        }

        render() {
            var hasMessage = !!this.state.message.UniqueId;
            return (
                <div className="s-MailViewer">
                    <div className="mail-actions">
                        <button type="button" className="btn btn-warning btn-sm" onClick={e => this.back()}>
                            &nbsp;&nbsp;<i className="fa fa-arrow-left"></i> {Q.text("Site.EmailClient.BackButton")}&nbsp;&nbsp;
                        </button>
                        {' '}
                        {hasMessage && <button type="button" className="btn btn-primary btn-sm" onClick={e => this.reply()}>
                            <i className="fa fa-mail-reply"></i> {Q.text("Site.EmailClient.ReplyButton")}
                        </button>}
                        {' '}
                        {hasMessage && <button type="button" className="btn btn-default btn-sm" onClick={e => this.reply(true)}>
                            <i className="fa fa-mail-reply-all"></i> {Q.text("Site.EmailClient.ReplyAllButton")}
                        </button >}
                        {' '}
                        {hasMessage && <button type="button" className="btn btn-default btn-sm" onClick={e => this.reply(false, true)}>
                            <i className="fa fa-mail-forward"></i> {Q.text("Site.EmailClient.ForwardButton")}
                        </button >}
                        {' '}
                        {hasMessage && <select style={{ padding: "4px", position: "relative", top: "2px" }} onChange={e => this.moveToFolder(e.target.value)}>
                            <option value="">{Q.text("Site.EmailClient.MoveToFolder")}</option>
                            {this.props.flatFolderList.filter(x => x.FullName != this.props.folder).map(x =>
                                <option key={x.FullName} value={x.FullName}>
                                    {mailboxFolderSelectPadding(x) + mailboxFolderName(x)}
                                </option>)}
                        </select>}
                        {' '}
                        {hasMessage && <button type="button" className="btn btn-danger btn-sm" onClick={e => this.deleteMessage()}>
                            <i className="fa fa-trash"></i> {Q.text("Site.EmailClient.DeleteButton")}
                        </button>}
                    </div>

                    {hasMessage && <div className="mail-info">
                        <div className="date-from">
                            <span className="from">{this.state.message.From}</span>{' '}
                            <span className="date">{this.getDateText()}</span>
                        </div>
                        <div className="subject">
                            {this.state.message.Subject}
                        </div>
                        <div className="to">
                            <label>{Q.text("Site.EmailClient.ToLabel")}</label>{' '}<span className="to">{this.state.message.To}</span>
                        </div>
                        {this.state.message.Cc && <div className="cc">
                            <label>{Q.text("Site.EmailClient.CCLabel")}</label>{' '}<span className="cc">{this.state.message.Cc}</span>
                        </div>}
                    </div>}

                    {hasMessage && <HtmlIFrame src="" className="message-body" frameBorder="0"
                        contents={this.state.message.HtmlBody} />}

                    {hasMessage && !!this.state.message.Attachments && !!this.state.message.Attachments.length && <div className="attachments">
                        <ul>
                            {this.state.message.Attachments.map(att =>
                                <li>
                                    <a href={att.DownloadUrl} target="_blank">
                                        <i className="fa fa-file"></i> {att.FileName}</a>
                                </li>)}
                        </ul>
                    </div>}
                </div>
            );
        }
    }
}